export class AtsRegex {
	public static NON_NEGATIVE_INTEGER = /^(0|[1-9]\d*)?$/;
	public static INTEGER = /^-?(0|[1-9]\d*)?$/;
	public static WHITESPACE = /\s+/g;
	public static DECIMAL = /^[+]?([0-9]+(?:[.][0-9]*)?|\.[0-9]+)$/;
}
